

import { apiUrl } from "./config.json";
import httpService from "./httpService";
let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = apiUrl + "/locationstate";
} else {
    apiEndpoint = apiUrl + "/locationstate";
}
   
 
  export async function getlocationStates(){
    const response=await httpService.get(`${apiEndpoint}/getlocationStates`);
    return response;
  }


   
  export default {
   
    getlocationStates
   
  }